import dayjs from 'dayjs'
import {useEffect, useState} from 'react'

const getCurrentTimerValue = (
  timestampStart: string,
  timestampEnd?: string,
) => {
  const dayJsEnd = dayjs(timestampEnd || undefined)

  const seconds = dayJsEnd.diff(timestampStart, 'seconds') % 60
  const minutes = dayJsEnd.diff(timestampStart, 'minutes') % 60
  const hours = dayJsEnd.diff(timestampStart, 'hours')

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}

interface useTimerProps {
  timestampEnd?: string
  timestampStart?: string
}

export const useTimer = ({timestampEnd, timestampStart}: useTimerProps) => {
  const [timerValue, setTimerValue] = useState<{
    hours: string
    minutes: string
    seconds: string
  }>(() => {
    if (timestampStart) {
      return getCurrentTimerValue(timestampStart, timestampEnd)
    }

    return {hours: '00', minutes: '00', seconds: '00'}
  })

  const isRunning = timestampStart && !timestampEnd

   
  useEffect(() => {
    if (timestampStart && isRunning) {
      const updateTimer = () => {
        setTimerValue(getCurrentTimerValue(timestampStart))
      }

      const interval = setInterval(updateTimer, 1000)

      return () => clearInterval(interval)
    }
  }, [timestampStart, isRunning])

  return timerValue
}
